/**
 * Testimonials for the split-screen /login and /register pages.
 *
 * Placeholder copy written for DashFlow (gestion de inventario multicanal).
 * Eric reemplaza con reales cuando los tenga.
 *
 * Avatars come from https://i.pravatar.cc/88?img={avatarSeed} which returns
 * realistic placeholder photos keyed by seed (1 to ~70).
 */
export interface AuthTestimonial {
  handle: string;
  avatarSeed: number;
  quote: string;
}

export const AUTH_TESTIMONIALS: AuthTestimonial[] = [
  {
    handle: '@moda.laprov',
    avatarSeed: 2,
    quote:
      'Vendemos en ML + TN + local. El stock se sincroniza solo. Dejamos de sobrevender tallas que no había.',
  },
  {
    handle: '@importa.sh',
    avatarSeed: 14,
    quote:
      'Cargo la orden de compra y el sistema calcula margen, IVA, costo en dólar real. Chau Excel infernal.',
  },
  {
    handle: '@fabrica.textil.cba',
    avatarSeed: 20,
    quote:
      'Manejamos 1200 SKUs con 2 personas. Antes eran 5. Los reportes de rentabilidad por producto nos cambiaron la vida.',
  },
];

export const AUTH_HEADLINE = 'Dejá de sobrevender. Dejá de contar a mano.';
export const AUTH_SUBTITLE = 'Lo que dicen sellers y fábricas reales.';

/**
 * Unsplash photo IDs suitable for the left panel background (warehouse / retail
 * / textile). The page composes the URL with `w=1600&q=80&auto=format&fit=crop`.
 */
export const AUTH_BG_UNSPLASH_IDS = [
  '1586528116311-ad8dd3c8310d',
  '1553413077-190dd305871c',
  '1441986300917-64674bd600d8',
];

export const authBgUrl = (id: string = AUTH_BG_UNSPLASH_IDS[0]) =>
  `https://images.unsplash.com/photo-${id}?w=1600&q=80&auto=format&fit=crop`;
